import React from "react";
import { Subheading } from "../home/Subheading";
import { RadioSetting } from "./RadioSetting";

export const Setting: React.FC<{
    setting:
        | "psalmCycle"
        | "lectionary"
        | "secondReadingToCompline"
        | "bibleTranslation"
        | "psalmsAtCompline"
        | "psalmsBold"
        | "invitatoryAntiphons"
        | "antiphonTones"
        | "teDeum"
        | "salutation"
        | "monarch"
        | "letUsBlessMattinsAndEvensong"
        | "hymnPosition"
        | "absolution"
        | "lordsPrayerAfterConfession"
        | "lordsPrayer"
        | "adventAndLentCollects"
        | "paschaNostrum"
        | "canticleAntiphonsExperimental"
        | "canticleTonesExperimental"
        | "experimentalChantRendering";
}> = (props) => {
    const { setting } = props;

    switch (setting) {
        case "psalmCycle":
            return (
                <>
                    <Subheading text="Psalm cycle" />
                    <RadioSetting
                        settingId="psalmCycle"
                        options={[
                            {
                                id: "bcp",
                                name: "1662 BCP 30-day cycle",
                            },
                            {
                                id: "cw",
                                name: "Common Worship cycle",
                            },
                            {
                                id: "acna",
                                name: "2019 BCP 60-day cycle",
                            },
                        ]}
                    />
                </>
            );
        case "lectionary":
            return (
                <>
                    <Subheading text="Lectionary" />
                    <RadioSetting
                        settingId="mattinsReadings"
                        options={[
                            {
                                id: "1961-morning",
                                name: "1961 English Lectionary",
                            },
                            {
                                id: "1922-morning",
                                name: "1922 English Lectionary",
                            },
                            {
                                id: "1871-morning",
                                name: "1871 English Lectionary",
                            },
                            {
                                id: "1662-morning",
                                name: "1662 English Lectionary",
                            },
                            {
                                id: "cw-morning",
                                name: "Common Worship Daily Prayer Lectionary",
                            },
                            {
                                id: "acna-morning-long",
                                name: "2019 ACNA Lectionary",
                            },
                            {
                                id: "acna-morning-short",
                                name: "2019 ACNA Lectionary (Short Readings)",
                            },
                        ]}
                    />
                </>
            );
        case "secondReadingToCompline":
            return (
                <>
                    <Subheading text="Lesson at Compline" />
                    <RadioSetting
                        settingId="secondReadingToCompline"
                        options={[
                            {
                                id: "no",
                                name: "Jeremiah 14:9",
                            },
                            {
                                id: "yes",
                                name: "Transfer the Second Lesson appointed at Evensong",
                            },
                        ]}
                    />
                </>
            );
        case "psalmsAtCompline":
            return (
                <>
                    <Subheading text="Psalms at Compline" />
                    <RadioSetting
                        settingId="psalmsAtCompline"
                        options={[
                            {
                                id: "compline-short",
                                name: "Cycle through the Psalms of Compline every three days: 4 & 134; 31a; 91",
                            },
                            {
                                id: "compline",
                                name: "All the Psalms of Compline: 4, 31a, 91, 134",
                            },
                            {
                                id: "same as evensong",
                                name: "The same as appointed at Evensong",
                            },
                        ]}
                    />
                </>
            );
        case "bibleTranslation":
            return (
                <>
                    <Subheading text="Bible translation for Lessons" />
                    <RadioSetting
                        settingId="bibleTranslation"
                        options={[
                            {
                                id: "ESV",
                                name: "ESV - English Standard Version",
                            },
                            {
                                id: "NRSV",
                                name: "NRSV - New Revised Standard Version",
                            },
                            {
                                id: "KJV",
                                name: "KJV - King James Version",
                            },
                            {
                                id: "RSV",
                                name: "RSV - Revised Standard Version",
                            },
                            {
                                id: "NASB",
                                name: "NASB - New American Standard Bible",
                            },
                        ]}
                    />
                </>
            );
        case "psalmsBold":
            return (
                <>
                    <Subheading text="Bold type in Psalms and Canticles" />
                    <RadioSetting
                        settingId="psalmsBold"
                        options={[
                            {
                                id: "all",
                                name: "Every verse",
                            },
                            {
                                id: "alternate",
                                name: "Alternate verses",
                            },
                            {
                                id: "none",
                                name: "None",
                            },
                        ]}
                    />
                </>
            );
        case "invitatoryAntiphons":
            return (
                <>
                    <Subheading text="Antiphons for the Invitatory Psalm" />
                    <RadioSetting
                        settingId="invitatoryAntiphons"
                        options={[
                            {
                                id: "always",
                                name: "Always",
                            },
                            {
                                id: "seasons",
                                name: "Except in Ordinary Time",
                            },
                            {
                                id: "never",
                                name: "Never",
                            },
                        ]}
                    />
                </>
            );
        case "antiphonTones":
            return (
                <>
                    <Subheading text="Tone for Antiphons" />
                    <RadioSetting
                        settingId="antiphonTones"
                        options={[
                            {
                                id: "solemn",
                                name: "Solemn tone",
                            },
                            {
                                id: "standard",
                                name: "Same tone as Psalm",
                            },
                        ]}
                    />
                </>
            );
        case "teDeum":
            return (
                <>
                    <Subheading text="Te Deum at Mattins" />
                    <RadioSetting
                        settingId="teDeum"
                        options={[
                            {
                                id: "always",
                                name: "Every day",
                            },
                            {
                                id: "feasts",
                                name: "Only on Feast Days",
                            },
                            {
                                id: "never",
                                name: "Never",
                            },
                        ]}
                    />
                </>
            );
        case "salutation":
            return (
                <>
                    <Subheading text="The Salutation" />
                    <RadioSetting
                        settingId="salutation"
                        options={[
                            {
                                id: "o lord hear our prayer",
                                name: 'For a lay Officiant: "O Lord hear our prayer. / And let our cry come unto thee."',
                            },
                            {
                                id: "the lord be with you",
                                name: 'For a Priest or Deacon: "The Lord be with you. / And with thy spirit."',
                            },
                        ]}
                    />
                </>
            );
        case "monarch":
            return (
                <>
                    <Subheading text="Monarchy?" />
                    <RadioSetting
                        settingId="monarch"
                        options={[
                            {
                                id: "yes",
                                name: '"O Lord save the King."',
                            },
                            {
                                id: "no",
                                name: '"O Lord save the State."',
                            },
                        ]}
                    />
                </>
            );
        case "letUsBlessMattinsAndEvensong":
            return (
                <>
                    <Subheading
                        text={
                            '"Let us bless the Lord..." at Mattins and Evensong'
                        }
                    />
                    <RadioSetting
                        settingId="letUsBlessMattinsAndEvensong"
                        options={[
                            {
                                id: "after collects",
                                name: "Immediately after the Collects",
                            },
                            {
                                id: "before grace",
                                name: "Immediately before the Grace",
                            },
                            {
                                id: "omit",
                                name: "Omit",
                            },
                        ]}
                    />
                </>
            );
        case "hymnPosition":
            return (
                <>
                    <Subheading text="Position of the Office Hymn" />
                    <RadioSetting
                        settingId="hymnPosition"
                        options={[
                            {
                                id: "anthem",
                                name: "Before the Grace (1662 BCP Anthem position)",
                            },
                            {
                                id: "before psalms",
                                name: "Before the Psalms",
                            },
                            {
                                id: "before canticle",
                                name: "Before the Gospel Canticle",
                            },
                            {
                                id: "omit",
                                name: "Omit the Office Hymn",
                            },
                        ]}
                    />
                </>
            );
        case "absolution":
            return (
                <>
                    <Subheading text="Absolution at Mattins and Evensong" />
                    <RadioSetting
                        settingId="absolution"
                        options={[
                            {
                                id: "pardon and peace collect",
                                name: "Collect for Trinity 21",
                            },
                            {
                                id: "bcp absolution",
                                name: "1662 Absolution by a priest",
                            },
                            {
                                id: "omit",
                                name: "Omit",
                            },
                        ]}
                    />
                </>
            );
        case "lordsPrayerAfterConfession":
            return (
                <>
                    <Subheading text="Lord's Prayer after the Confession" />
                    <RadioSetting
                        settingId="lordsPrayerAfterConfession"
                        options={[
                            {
                                id: "omit",
                                name: "Omit",
                            },
                            {
                                id: "said",
                                name: "Said",
                            },
                            {
                                id: "sung",
                                name: "Sung",
                            },
                        ]}
                    />
                </>
            );
        case "lordsPrayer":
            return (
                <>
                    <Subheading text="Text of the Lord's Prayer" />
                    <RadioSetting
                        settingId="lordsPrayer"
                        options={[
                            {
                                id: "standard",
                                name: "Standard (Our Father who art...)",
                            },
                            {
                                id: "bcp",
                                name: "1662 text (Our Father which art...)",
                            },
                        ]}
                    />
                </>
            );
        case "adventAndLentCollects":
            return (
                <>
                    <Subheading text="Advent 1 and Ash Wednesday Collects throughout the season" />
                    <RadioSetting
                        settingId="adventAndLentCollects"
                        options={[
                            {
                                id: "repeat",
                                name: "Repeat every day after the Collect of the Day",
                            },
                            {
                                id: "dont repeat",
                                name: "Don't repeat",
                            },
                        ]}
                    />
                </>
            );
        case "paschaNostrum":
            return (
                <>
                    <Subheading text="Pascha Nostrum at Easter" />
                    <RadioSetting
                        settingId="paschaNostrum"
                        options={[
                            {
                                id: "octave",
                                name: "Pascha Nostrum replaces Venite throughout the octave of Easter",
                            },
                            {
                                id: "day",
                                name: "Pascha Nostrum replaces Venite on Easter Sunday only",
                            },
                            {
                                id: "no",
                                name: "Keep Venite throughout",
                            },
                        ]}
                    />
                </>
            );
        case "canticleAntiphonsExperimental":
            return (
                <>
                    <Subheading text="Debug" />
                    <RadioSetting
                        settingId="canticleAntiphonsExperimental"
                        options={[
                            {
                                id: "none",
                                name: "Off",
                            },
                            {
                                id: "sarum",
                                name: "On",
                            },
                        ]}
                    />
                </>
            );
        case "canticleTonesExperimental":
            return (
                <>
                    <Subheading text="Debug 2" />
                    <RadioSetting
                        settingId="canticleTonesExperimental"
                        options={[
                            {
                                id: "simplified",
                                name: "Off",
                            },
                            {
                                id: "sarum",
                                name: "On",
                            },
                        ]}
                    />
                </>
            );
        case "experimentalChantRendering":
            return (
                <>
                    <Subheading text="Debug 3" />
                    <RadioSetting
                        settingId="experimentalChantRendering"
                        options={[
                            {
                                id: "off",
                                name: "Off",
                            },
                            {
                                id: "on",
                                name: "On",
                            },
                        ]}
                    />
                </>
            );
    }
    return <></>;
};
